import React from 'react';
import NumberFormat from 'react-number-format';

const number = (props) => {
    return <div><NumberFormat value={props.value} displayType={'text'} thousandSeparator={true}></NumberFormat> <span>{props.symbol && props.value ? " ₮" : null}</span></div>;
}

export default number;